// @ts-nocheck

import { createSelector } from 'reselect';

import { getMatchIdFromProps } from '../../selectors/_propsGetters_';
import {
  selectEntitiesMatchesEntity,
  selectEntitiesMatchesEntityIsOutright,
  selectEntitiesMatchesEntityRoundName,
  selectEntitiesMatchesEntityScore,
  selectEntitiesMatchesEntitySportId,
  selectEntitiesMatchesEntityStatus,
  selectEntitiesMatchesEntitySummaryComputed,
  selectEntitiesMatchesEntityTitle,
} from '../../selectors/entities/matches/entitiesMatchesPrimary.selector';
import {
  selectIsMatchMMLoading,
  selectMatchViewMode,
  selectMatchSportsEntitySportName,
  selectMatchTournamentsEntityTournamentName,
} from '../../selectors/match.selector';
import { type MatchStatus } from '../../types/match';
import { type MatchViewMode } from '../../types/matchView';
import { type Selector } from '../../types/selectors';
import { type SportId } from '../../types/sports';

const selectIsNull: Selector<boolean> = createSelector([selectEntitiesMatchesEntity], (match) => match === null);

const selectIsLoading: Selector<boolean> = createSelector(
  [selectEntitiesMatchesEntity],
  (match) => match === undefined,
);

type RouteMatchPropsType = {
  matchId?: number;
  loading: boolean;
  isNull: boolean;
  isOutright: boolean;
  status?: MatchStatus;
  sportId?: SportId;
  score?: string;
  title?: string;
  roundName?: string;
  tournamentName?: string;
  sportName?: string;
  summaryComputed: boolean;
  isMMLoading: boolean;
  matchViewMode: MatchViewMode;
};

const selectRouteMatchProps: Selector<RouteMatchPropsType> = createSelector(
  [
    getMatchIdFromProps,
    selectIsNull,
    selectIsLoading,
    selectEntitiesMatchesEntityIsOutright,
    selectEntitiesMatchesEntityStatus,
    selectEntitiesMatchesEntitySportId,
    selectEntitiesMatchesEntityScore,
    selectEntitiesMatchesEntityTitle,
    selectEntitiesMatchesEntityRoundName,
    selectMatchSportsEntitySportName,
    selectMatchTournamentsEntityTournamentName,
    selectEntitiesMatchesEntitySummaryComputed,
    selectIsMatchMMLoading,
    selectMatchViewMode,
  ],
  (
    matchId,
    isNull,
    loading,
    isOutright,
    status,
    sportId,
    score,
    title,
    roundName,
    sportName,
    tournamentName,
    summaryComputed,
    isMMLoading,
    matchViewMode,
  ) => ({
    matchId,
    loading,
    isNull,
    isOutright,
    status,
    sportId,
    score,
    title,
    roundName,
    tournamentName,
    sportName,
    summaryComputed,
    isMMLoading,
    matchViewMode,
  }),
);

export default selectRouteMatchProps;
